module.exports = "<div class=\"form-group\">\n\t<label *ngIf=\"label\">{{label}} <span class=\"required\" *ngIf=\"required\">*</span></label>\n\t<ngb-timepicker [(ngModel)]=\"time\" (ngModelChange)=\"onSelectTime(time)\"></ngb-timepicker>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/cycler/apollo-admin/src/src/app/timepicker/timepicker.component.html
// module id = ../../../../../src/app/timepicker/timepicker.component.html
// module chunks = 1